export enum WithdrawStepsEnum {
  INIT = 1,
  CONNECT_WALLET,
  SECURITY_VERIFICATION,
  TWO_FA_FACTOR_REQUIRED,
  FINAL_STEP,
  APPROVE_TRANSACTION,
  APPROVE_TRANSACTION_SUCCESS,
  APPROVE_TRANSACTION_FAIL,
  NO_KYC
}

export interface confirmNFTWithdrawRequest {
  userPackageId?: number;
  walletAddress: string | undefined;
  walletAddressSign: string;
  emailCode: string;
  twoFACode: string;
}
